export default __webpack_public_path__ + "static/media/comercio_11.650cb482.png";